import { z } from 'zod';

export const baseIpptPerformanceFormSchema = z.object({
    pushUps: z.number().min(0).nullable().optional(),
    sitUps: z.number().min(0).nullable().optional(),
    pullUps: z.number().min(0).nullable().optional(),
    runTime: z.number().min(0).nullable().optional(),
    points: z.number().min(0).nullable().optional(),
    date: z.date(),
});

export const createIpptPerformanceFormSchema = baseIpptPerformanceFormSchema
    .extend({
        userId: z.string().min(1, { message: 'Trainee is required' }),
        assessmentRunId: z.string().nullable().optional(),
        isTiedToAssessmentRun: z.boolean(),
    })
    .refine(data => !(data.isTiedToAssessmentRun && !data.assessmentRunId), {
        message: 'Assessment run is required when tying to an assessment run',
        path: ['assessmentRunId'],
    });

export type CreateIpptPerformanceFormData = z.infer<typeof createIpptPerformanceFormSchema>;

export type EditIpptPerformanceFormData = z.infer<typeof baseIpptPerformanceFormSchema> & {
    runTimeMinutes?: number | null;
    runTimeSeconds?: number | null;
    assessmentRunId?: string | null;
    isTiedToAssessmentRun?: boolean;
};

export const ipptPerformanceDefaultFormValues: CreateIpptPerformanceFormData = {
    pushUps: null,
    sitUps: null,
    pullUps: null,
    runTime: null,
    points: null,
    date: new Date(),
    assessmentRunId: null,
    isTiedToAssessmentRun: false,
    userId: '',
};
